// B35-4 to B35-7 (card V2) — walkthrough cycles (standard + custom), IT controls the auditor adds / deletes, adjustable
// columns and growing text cells. EN + AR. The three new standard cycle names go into the existing wt.process.* keys.
export const I18N_B35C = {
  en: {
    wt: {
      process: {
        fixed_assets: "Fixed assets / capex",
        borrowings_treasury: "Borrowings and treasury",
        tax_zakat: "Tax and zakat",
      },
      col: { objective: "Objective" },
    },
    b35c: {
      addCycle: "Add cycle",
      cycleNamePh: "Name of the cycle (e.g. Grants and subsidies)",
      cycleNameRequired: "Type a name for the cycle.",
      saveCycle: "Save cycle",
      cancel: "Cancel",
      cycleAdded: "Cycle added",
      renameCycle: "Rename",
      cycleRenamed: "Cycle renamed",
      deleteCycle: "Delete cycle",
      deleteCycleConfirm: "Delete the cycle \"{name}\"? A cycle can be deleted only while it has no walkthrough and no file.",
      cycleDeleted: "Cycle deleted",
      customCycle: "Added for this engagement",
      addItControl: "Add IT control",
      itDomain: "Domain",
      otherDomain: "Other (type a name)",
      otherDomainPh: "Name of the domain",
      itDescriptionPh: "Description of the IT control",
      itDescriptionRequired: "Type a description of the IT control.",
      itDomainNameRequired: "Type the name of the domain.",
      addItControlSave: "Add",
      itControlAdded: "IT control added",
      deleteRow: "Delete",
      deleteItControlConfirm: "Delete this IT control? It will not come back when the page is reloaded.",
      itControlDeleted: "IT control deleted",
      cycleCol: "Cycle",
    },
  },
  ar: {
    wt: {
      process: {
        fixed_assets: "الأصول الثابتة / النفقات الرأسمالية",
        borrowings_treasury: "القروض والخزينة",
        tax_zakat: "الضرائب والزكاة",
      },
      col: { objective: "الهدف" },
    },
    b35c: {
      addCycle: "إضافة دورة",
      cycleNamePh: "اسم الدورة (مثال: المنح والإعانات)",
      cycleNameRequired: "اكتب اسماً للدورة.",
      saveCycle: "حفظ الدورة",
      cancel: "إلغاء",
      cycleAdded: "تمت إضافة الدورة",
      renameCycle: "إعادة تسمية",
      cycleRenamed: "تمت إعادة تسمية الدورة",
      deleteCycle: "حذف الدورة",
      deleteCycleConfirm: "حذف الدورة \"{name}\"؟ يمكن حذف الدورة فقط إذا لم يكن فيها اختبار تتبع ولا ملف.",
      cycleDeleted: "تم حذف الدورة",
      customCycle: "مضافة لهذا الارتباط",
      addItControl: "إضافة ضابط تقنية معلومات",
      itDomain: "المجال",
      otherDomain: "أخرى (اكتب اسماً)",
      otherDomainPh: "اسم المجال",
      itDescriptionPh: "وصف ضابط تقنية المعلومات",
      itDescriptionRequired: "اكتب وصفاً لضابط تقنية المعلومات.",
      itDomainNameRequired: "اكتب اسم المجال.",
      addItControlSave: "إضافة",
      itControlAdded: "تمت إضافة ضابط تقنية المعلومات",
      deleteRow: "حذف",
      deleteItControlConfirm: "حذف ضابط تقنية المعلومات هذا؟ لن يعود عند إعادة تحميل الصفحة.",
      itControlDeleted: "تم حذف ضابط تقنية المعلومات",
      cycleCol: "الدورة",
    },
  },
};

export default I18N_B35C;
